// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eEQU","footer":"styles_footer__2p9T7","passCodeTooltip":"styles_passCodeTooltip__5ZgBj"};